module.exports = __webpack_public_path__ + "media/images/signatures/2024/zsofi-5e79adc3f26e69f6b8d2fdeb242f39cc.png";